angular.module('controllers').controller('driverMessageController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window', 'Mqtt',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval, $window, Mqtt) {

		Mqtt.connect($rootScope.mq);

		$rootScope.path = '/driver-message';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'driver-message';
		$scope.pathTemplate = 'distribution/drivermessages';
		$scope.title = 'Mesaje dispecerat - soferi';
		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'created_at';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'date':{'label': 'Data', 'filter': 0, 'filterType': 'input'},
			'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'}
		};
		$scope.additionals['publicUserPath'] = '/images/users';
		$scope.additionals['publicDriverPath'] = '/images/drivers';
		$scope.additionals['publicDriverPath180'] = $scope.additionals['publicDriverPath']+'/thumb180x180';
		$scope.additionals['publicDriverPath250'] = $scope.additionals['publicDriverPath']+'/thumb250x250';
		$scope.additionals['publicUserPath'] = '/images/users';

		$scope.search.order = 'desc';
		$scope.additionals['content_type'] = 'form-urlencoded';

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['drivers'] = data.drivers;
					$scope.columns.driver_name.options = [{id:'', value:''}];
					angular.forEach(data.drivers, function (item, key) {
						$scope.columns.driver_name.options.push({id:item.driver_name, value:item.driver_name});
					});
				});
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.maxDate = new Date();
		$scope.minDate = '2010-01-01';
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

		$scope.controlSH = true;
		$scope.action = 'chat';

		/* delete model */
		$scope.deleteModel = function (ev, path, model) {
			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$mdDialog.show({
				controller: DialogController,
				templateUrl: 'deleteDialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {pathTemplate: $scope.pathTemplate, model: model, additionals: $scope.additionals, path: path}
			}).then(function (destroyModel) {
				var no_pages = Math.ceil(($scope.total - 1) / $scope.state.itemsPerPage);
				if ($scope.state.page > no_pages) {
					$scope.state.page = no_pages;
				}
				if($scope.state.itemsPerPage == 0) {
					var position = $scope.models.map(function (e) {
						return e[$rootScope.typeId];
					}).indexOf(model[$rootScope.typeId]);
					$scope.models.splice(position, 1);
				}
				if($scope.state.itemsPerPage != 0) {
					$scope.getPaginateModel(path, $scope.state.page, $scope.state.itemsPerPage);
				}
			});

			DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals', 'path'];
			function DialogController($scope, $mdDialog, pathTemplate, model, additionals, path) {
				$scope.pathTemplate = pathTemplate;
				$scope.cancel = function () {
					$mdDialog.cancel();
				};
				$scope.additionals = additionals;
				$scope.modelData = model;

				/* save a model */
				$scope.destroyModel = function () {
					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;

					var post = model;
					post['route'] = 'destroy';
					Crud.post('form-urlencoded', post, path + '/destroy')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
								if (!angular.isUndefined($scope.additionals['functionResult'])) {
									$scope.additionals['functionResult'](ev, data);
								}
							}
							$scope.isLoading = false;
							$mdDialog.hide();
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.errors = data.errors;
							$scope.isLoading = false;
							$scope.additionals['buttonDisabled'] = false;
						});
				};
			}
		};

		/* delete multiple models */
		$scope.deleteMultipleModel = function (ev, path) {
			$scope.additionals['invalid'] = '';
			if ($scope.checkSelected($scope.selected, ev)) {
				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'deleteMultipleDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {pathTemplate: $scope.pathTemplate, selected:$scope.selected, selectedAll:$scope.selectedAll, additionals: $scope.additionals}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if($scope.state.itemsPerPage == 0) {
							angular.forEach($scope.selected, function (item, index) {
								var position = $scope.models.map(function (e) {
									return e[$rootScope.typeId];
								}).indexOf(index);
								$scope.models.splice(position, 1);
							});
						}
						if($scope.state.itemsPerPage != 0) {
							$scope.getPaginateModel(path, $scope.state.page, $scope.state.itemsPerPage);
						}
					}
					$scope.selected = {};
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'selected', 'selectedAll', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, selected, selectedAll, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.selectedAll = selectedAll;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					$scope.destroyMultipleModel = function () {
						$scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;

						var post = {};
						post['models'] = $scope.selected;
						post['route'] = 'deleteMultiple';

						Crud.post('form-urlencoded', post, path + '/deleteMultiple')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									if (!angular.isUndefined($scope.additionals['functionResult'])) {
										$scope.additionals['functionResult'](ev, data);
									}
								}
								$scope.selectedAll = false;
								$scope.selected = {};
								$scope.isLoading = false;
								$mdDialog.hide();
								$scope.additionals['buttonDisabled'] = false;
							}).error(function (data) {
								$scope.errors = data.errors;
								$scope.isLoading = false;
								$scope.additionals['buttonDisabled'] = false;
							});
					};
				}
			}
		};

		/* show model */
		$scope.showModel = function (ev, path, model) {
			$scope.history = model;
			$scope.action = 'show';

			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$scope.modelData = model;

			$scope.additionals['buttonDisabled'] = true;
			$scope.isLoading = true;

			var post = model;
			post['route'] = 'show';
			Crud.post('form-urlencoded', post, path + '/show')
				.success(function (data) {
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						$scope.messages_drivers = data;
					}
					$scope.isLoading = false;
					$mdDialog.hide();
					$scope.additionals['buttonDisabled'] = false;
				})
				.error(function (data) {
					$scope.errors = data.errors;
					$scope.isLoading = false;
					$scope.additionals['buttonDisabled'] = false;
				});

		};

		$scope.cancel = function () {
			$scope.action = 'chat';
			$scope.messages_drivers = [];
		}

		$scope.getDrivers = function () {
			Crud.get($scope.path+'/getDrivers')
				.success(function (data) {
					$scope.drivers = data;
				});
		}
		$scope.getDrivers();

		$scope.selectDriver = function (driver, keyDriver) {
			$scope.currentDriver = driver;
			$scope.drivers[keyDriver]['no_unread_message'] = 0;
			$scope.currentDriverClass = {};
			$scope.currentDriverClass[driver.id] = 'driver-active';

			$scope.getDriverMessage(driver.id);

		};

		$scope.messages_drivers = [];
		$scope.isLoading = false;
		$scope.saveDriverMessage = function (ev, model) {
			/* on enter */
			//if(ev.keyCode == 13) {
			$scope.additionals['buttonDisabled'] = true;
			$scope.isLoading = true;

			var post = model;
			post['route'] = 'store';
			if (!angular.isUndefined($scope.currentDriver)) {
				post['driver_id'] = $scope.currentDriver.id;
			}

			Crud.post('form-urlencoded', post, $scope.path + '/store')
				.success(function (data) {
					$scope.modelData.message = '';
					if(data.length > 0) {
						//$scope.messages_drivers.push(data[0]);
					}

					angular.element(document.querySelector('.list-message')).animate({ scrollTop: 5000 }, '500');
					$scope.errors = [];

					$scope.additionals['buttonDisabled'] = false;
					$scope.isLoading = false;

				}).error(function (data) {
					$scope.errors = data.errors;
					$scope.additionals['buttonDisabled'] = false;
					$scope.isLoading = false;
				});
			//}

		};

		$scope.getDriverMessage = function (driverId) {
			Crud.get($scope.path+'/getDriverMessage?driver_id='+driverId)
				.success(function (data) {
					$scope.messages_drivers = data;
					angular.element(document.querySelector('.list-message')).animate({ scrollTop: 5000 }, '500');
				});
		}

		/* mqtt */
		Mqtt.addListener({'id': 'driver_message_channel', 'funct': driverMessageMqtt});
		function driverMessageMqtt(result, channel) {
			//console.log(channel)
			//console.log(result)

			var model = result[0];
			if (channel == 'driver_message_channel') {
				$timeout(function () {
					if (!angular.isUndefined($scope.currentDriver)) {
						if($scope.currentDriver.id == model.driver_id) {
							$scope.messages_drivers.push(model);
							angular.element(document.querySelector('.list-message')).animate({ scrollTop: 5000 }, '500');
						} else {
							var positionDriver = $scope.drivers.map(function (e) {
								return e['id'];
							}).indexOf(model.driver_id);
							$scope.drivers[positionDriver]['no_unread_message'] = $scope.drivers[positionDriver]['no_unread_message'] + 1;
						}
					} else {
						var positionDriver = $scope.drivers.map(function (e) {
							return e['id'];
						}).indexOf(model.driver_id);
						$scope.drivers[positionDriver]['no_unread_message'] = $scope.drivers[positionDriver]['no_unread_message'] + 1;
					}
				}, 100);
			}

			if (channel == 'driver_message_reverse_channel') {
				$timeout(function () {
					if (!angular.isUndefined($scope.currentDriver)) {
						if($scope.currentDriver.id == model.driver_id) {
							$scope.messages_drivers.push(model);
							angular.element(document.querySelector('.list-message')).animate({ scrollTop: 5000 }, '500');
						} else {
							var positionDriver = $scope.drivers.map(function (e) {
								return e['id'];
							}).indexOf(model.driver_id);
							$scope.drivers[positionDriver]['no_unread_message'] = $scope.drivers[positionDriver]['no_unread_message'] + 1;
						}
					} else {
						var positionDriver = $scope.drivers.map(function (e) {
							return e['id'];
						}).indexOf(model.driver_id);
						$scope.drivers[positionDriver]['no_unread_message'] = $scope.drivers[positionDriver]['no_unread_message'] + 1;
					}
				}, 100);
			}

		}



	}]
);
